// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"31d6cfe0","230":"31d6cfe0","374":"31d6cfe0","388":"31d6cfe0","457":"31d6cfe0","583":"a04e8838","634":"9bd9eb59","773":"31d6cfe0","874":"31d6cfe0","977":"d8f00cde"}[chunkId] + ".chunk.css";
};